import { render, staticRenderFns } from "./TickerAdminViewCrypto.vue?vue&type=template&id=31b77657&scoped=true"
import script from "./TickerAdminViewCrypto.vue?vue&type=script&lang=js"
export * from "./TickerAdminViewCrypto.vue?vue&type=script&lang=js"
import style0 from "./TickerAdminViewCrypto.vue?vue&type=style&index=0&id=31b77657&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b77657",
  null
  
)

export default component.exports